import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gallery-track" }
const _hoisted_2 = { class: "gallery-image-wrapper" }

import {useStore} from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryImage',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).images.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gallery-prev",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).prevImage()))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "35.739",
            height: "35.739",
            viewBox: "0 0 35.739 35.739"
          }, [
            _createElementVNode("path", {
              d: "M0,0H25.271L0,25.271Z",
              transform: "translate(0 17.869) rotate(-45)",
              fill: "#dbd8d8"
            })
          ], -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "gallery" }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            class: "gallery-image",
            key: _unref(store).currentImage,
            style: _normalizeStyle({'background-image': `url(${_unref(store).currentImage})`})
          }, null, 4 /* STYLE */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    (_unref(store).images.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "gallery-next",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).prevImage()))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "35.739",
            height: "35.739",
            viewBox: "0 0 35.739 35.739"
          }, [
            _createElementVNode("path", {
              d: "M0,0H25.271L0,25.271Z",
              transform: "translate(35.739 17.869) rotate(135)",
              fill: "#dbd8d8"
            })
          ], -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})